// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/store.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreatePolicyRequest, CreatePortalInstanceRequest, CreatePortalInstanceResponse, CreatePortalKeyRequest, CreatePortalKeyResponse, DeletePolicyRequest, DeletePortalInstanceRequest, GetPortalInstanceRequest, GetPublicStoreInfoRequest, GetStoreConfigRequest, ListPoliciesRequest, ListPoliciesResponse, ListPortalInstancesRequest, ListPortalInstancesResponse, ListPortalKeysRequest, ListPortalKeysResponse, PortalInstance, PublicStoreInfo, PublishPortalInstanceRequest, RefreshRecommendationsRequest, RefreshRecommendationsResponse, RevokePortalKeyRequest, RevokePortalKeyResponse, StoreConfig, StorePolicy, UpdatePolicyRequest, UpdatePortalInstanceRequest, UpdateStoreConfigRequest } from "./store_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.StoreService
 */
export const StoreService = {
  typeName: "omnios.v1.StoreService",
  methods: {
    /**
     * Portal Instance CRUD
     *
     * @generated from rpc omnios.v1.StoreService.CreatePortalInstance
     */
    createPortalInstance: {
      name: "CreatePortalInstance",
      I: CreatePortalInstanceRequest,
      O: CreatePortalInstanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.GetPortalInstance
     */
    getPortalInstance: {
      name: "GetPortalInstance",
      I: GetPortalInstanceRequest,
      O: PortalInstance,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.ListPortalInstances
     */
    listPortalInstances: {
      name: "ListPortalInstances",
      I: ListPortalInstancesRequest,
      O: ListPortalInstancesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.UpdatePortalInstance
     */
    updatePortalInstance: {
      name: "UpdatePortalInstance",
      I: UpdatePortalInstanceRequest,
      O: PortalInstance,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.DeletePortalInstance
     */
    deletePortalInstance: {
      name: "DeletePortalInstance",
      I: DeletePortalInstanceRequest,
      O: PortalInstance,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.PublishPortalInstance
     */
    publishPortalInstance: {
      name: "PublishPortalInstance",
      I: PublishPortalInstanceRequest,
      O: PortalInstance,
      kind: MethodKind.Unary,
    },
    /**
     * Portal keys (omnios_pk_* — external API auth for portal instances)
     *
     * @generated from rpc omnios.v1.StoreService.CreatePortalKey
     */
    createPortalKey: {
      name: "CreatePortalKey",
      I: CreatePortalKeyRequest,
      O: CreatePortalKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.ListPortalKeys
     */
    listPortalKeys: {
      name: "ListPortalKeys",
      I: ListPortalKeysRequest,
      O: ListPortalKeysResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.RevokePortalKey
     */
    revokePortalKey: {
      name: "RevokePortalKey",
      I: RevokePortalKeyRequest,
      O: RevokePortalKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Store config (per-portal-instance)
     *
     * @generated from rpc omnios.v1.StoreService.GetStoreConfig
     */
    getStoreConfig: {
      name: "GetStoreConfig",
      I: GetStoreConfigRequest,
      O: StoreConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.UpdateStoreConfig
     */
    updateStoreConfig: {
      name: "UpdateStoreConfig",
      I: UpdateStoreConfigRequest,
      O: StoreConfig,
      kind: MethodKind.Unary,
    },
    /**
     * Policies (per-portal-instance)
     *
     * @generated from rpc omnios.v1.StoreService.CreatePolicy
     */
    createPolicy: {
      name: "CreatePolicy",
      I: CreatePolicyRequest,
      O: StorePolicy,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.UpdatePolicy
     */
    updatePolicy: {
      name: "UpdatePolicy",
      I: UpdatePolicyRequest,
      O: StorePolicy,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.DeletePolicy
     */
    deletePolicy: {
      name: "DeletePolicy",
      I: DeletePolicyRequest,
      O: StorePolicy,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.ListPolicies
     */
    listPolicies: {
      name: "ListPolicies",
      I: ListPoliciesRequest,
      O: ListPoliciesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.StoreService.GetPublicStoreInfo
     */
    getPublicStoreInfo: {
      name: "GetPublicStoreInfo",
      I: GetPublicStoreInfoRequest,
      O: PublicStoreInfo,
      kind: MethodKind.Unary,
    },
    /**
     * Recommendations
     *
     * @generated from rpc omnios.v1.StoreService.RefreshRecommendations
     */
    refreshRecommendations: {
      name: "RefreshRecommendations",
      I: RefreshRecommendationsRequest,
      O: RefreshRecommendationsResponse,
      kind: MethodKind.Unary,
    },
  }
};

